import { render, staticRenderFns } from "./AddLicenseModal.vue?vue&type=template&id=6203a864&scoped=true&"
import script from "./AddLicenseModal.vue?vue&type=script&lang=js&"
export * from "./AddLicenseModal.vue?vue&type=script&lang=js&"
import style0 from "./AddLicenseModal.vue?vue&type=style&index=0&id=6203a864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6203a864",
  null
  
)

export default component.exports